export default {
  title: '生産管理',
  productionPlan: '生産計画',
};
